import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoadingButton from "../components/LoadingButton";
import { useAuth } from "../contexts/AuthContext";
import api from "../services/api";

export default function ChangePassword() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError(t("change_password.error_short", "Password must be at least 8 characters"));
      return;
    }
    if (password !== confirm) {
      setError(t("change_password.error_mismatch", "Passwords do not match"));
      return;
    }
    setLoading(true);
    try {
      const res = await api.updateUser({ password });
      if (res?.success) {
        await refresh();
        navigate("/");
      } else {
        setError(res?.message || t("change_password.error_generic"));
      }
    } catch (err) {
      setError(err.response?.data?.message || t("change_password.error_generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white p-8 rounded-3xl border border-white/60 shadow-lg">
        <h2 className="text-2xl font-bold mb-2">{t("change_password.title", "Set a New Password")}</h2>
        <p className="text-sm text-gray-600 mb-6">{t("change_password.subtitle", "You must set a new password that you'll use to log in from now on.")}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">{t("change_password.password_label", "New password")}</label>
            <input type="password" className="mt-1 w-full border border-gray-200 p-3 rounded-xl" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">{t("change_password.confirm_label", "Confirm password")}</label>
            <input type="password" className="mt-1 w-full border border-gray-200 p-3 rounded-xl" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          </div>
          {error && <div className="text-red-600 text-sm">{error}</div>}
          <div className="flex justify-end">
            <LoadingButton type="submit" loading={loading} className="bg-primary-600 text-white px-4 py-2 rounded-xl">{t("change_password.save_button", "Save password")}</LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
}
